// source: proto/mdining.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var google_api_annotations_pb = require('../google/api/annotations_pb.js');

goog.object.extend(proto, google_api_annotations_pb);

var proto_dininghalls_pb = require('../proto/dininghalls_pb.js');

goog.object.extend(proto, proto_dininghalls_pb);

var proto_items_pb = require('../proto/items_pb.js');

goog.object.extend(proto, proto_items_pb);

var proto_filterableentries_pb = require('../proto/filterableentries_pb.js');

goog.object.extend(proto, proto_filterableentries_pb);

var proto_menu_pb = require('../proto/menu_pb.js');

goog.object.extend(proto, proto_menu_pb);

var proto_food_pb = require('../proto/food_pb.js');

goog.object.extend(proto, proto_food_pb);

var proto_foodstat_pb = require('../proto/foodstat_pb.js');

goog.object.extend(proto, proto_foodstat_pb);

var proto_hearts_pb = require('../proto/hearts_pb.js');

goog.object.extend(proto, proto_hearts_pb);
goog.exportSymbol('proto.mdining.AllReply', null, global);
goog.exportSymbol('proto.mdining.AllRequest', null, global);
goog.exportSymbol('proto.mdining.DiningHallsReply', null, global);
goog.exportSymbol('proto.mdining.DiningHallsRequest', null, global);
goog.exportSymbol('proto.mdining.FilterableEntriesReply', null, global);
goog.exportSymbol('proto.mdining.FilterableEntriesRequest', null, global);
goog.exportSymbol('proto.mdining.FoodReply', null, global);
goog.exportSymbol('proto.mdining.FoodRequest', null, global);
goog.exportSymbol('proto.mdining.FoodStatsReply', null, global);
goog.exportSymbol('proto.mdining.FoodStatsRequest', null, global);
goog.exportSymbol('proto.mdining.HeartsReply', null, global);
goog.exportSymbol('proto.mdining.HeartsRequest', null, global);
goog.exportSymbol('proto.mdining.ItemsReply', null, global);
goog.exportSymbol('proto.mdining.ItemsRequest', null, global);
goog.exportSymbol('proto.mdining.MenuReply', null, global);
goog.exportSymbol('proto.mdining.MenuRequest', null, global);
goog.exportSymbol('proto.mdining.SummaryStatsReply', null, global);
goog.exportSymbol('proto.mdining.SummaryStatsRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.mdining.FoodStatsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.FoodStatsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FoodStatsRequest.displayName = 'proto.mdining.FoodStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.FoodStatsReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.FoodStatsReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.FoodStatsReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FoodStatsReply.displayName = 'proto.mdining.FoodStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.SummaryStatsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.SummaryStatsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.SummaryStatsRequest.displayName = 'proto.mdining.SummaryStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.SummaryStatsReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.SummaryStatsReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.SummaryStatsReply.displayName = 'proto.mdining.SummaryStatsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.DiningHallsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.DiningHallsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.DiningHallsRequest.displayName = 'proto.mdining.DiningHallsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.DiningHallsReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.DiningHallsReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.DiningHallsReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.DiningHallsReply.displayName = 'proto.mdining.DiningHallsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.ItemsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.ItemsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.ItemsRequest.displayName = 'proto.mdining.ItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.ItemsReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.ItemsReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.ItemsReply.displayName = 'proto.mdining.ItemsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.FilterableEntriesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.FilterableEntriesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FilterableEntriesRequest.displayName = 'proto.mdining.FilterableEntriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.FilterableEntriesReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.FilterableEntriesReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.FilterableEntriesReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FilterableEntriesReply.displayName = 'proto.mdining.FilterableEntriesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.AllRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.AllRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.AllRequest.displayName = 'proto.mdining.AllRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.AllReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.AllReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.AllReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.AllReply.displayName = 'proto.mdining.AllReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.MenuRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.MenuRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.MenuRequest.displayName = 'proto.mdining.MenuRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.MenuReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.MenuReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.MenuReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.MenuReply.displayName = 'proto.mdining.MenuReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.FoodRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.mdining.FoodRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FoodRequest.displayName = 'proto.mdining.FoodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.FoodReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.FoodReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.FoodReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.FoodReply.displayName = 'proto.mdining.FoodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.HeartsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.HeartsRequest.repeatedFields_, null);
};

goog.inherits(proto.mdining.HeartsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.HeartsRequest.displayName = 'proto.mdining.HeartsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.mdining.HeartsReply = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mdining.HeartsReply.repeatedFields_, null);
};

goog.inherits(proto.mdining.HeartsReply, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mdining.HeartsReply.displayName = 'proto.mdining.HeartsReply';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FoodStatsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FoodStatsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FoodStatsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FoodStatsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FoodStatsRequest}
 */


proto.mdining.FoodStatsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FoodStatsRequest();
  return proto.mdining.FoodStatsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FoodStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FoodStatsRequest}
 */


proto.mdining.FoodStatsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FoodStatsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FoodStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FoodStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FoodStatsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.FoodStatsReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FoodStatsReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FoodStatsReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FoodStatsReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FoodStatsReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      foodstatsList: jspb.Message.toObjectList(msg.getFoodstatsList(), proto_foodstat_pb.FoodStat.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FoodStatsReply}
 */


proto.mdining.FoodStatsReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FoodStatsReply();
  return proto.mdining.FoodStatsReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FoodStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FoodStatsReply}
 */


proto.mdining.FoodStatsReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_foodstat_pb.FoodStat();
        reader.readMessage(value, proto_foodstat_pb.FoodStat.deserializeBinaryFromReader);
        msg.addFoodstats(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FoodStatsReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FoodStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FoodStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FoodStatsReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFoodstatsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_foodstat_pb.FoodStat.serializeBinaryToWriter);
  }
};
/**
 * repeated FoodStat foodStats = 1;
 * @return {!Array<!proto.mdining.FoodStat>}
 */


proto.mdining.FoodStatsReply.prototype.getFoodstatsList = function () {
  return (
    /** @type{!Array<!proto.mdining.FoodStat>} */
    jspb.Message.getRepeatedWrapperField(this, proto_foodstat_pb.FoodStat, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.FoodStat>} value
 * @return {!proto.mdining.FoodStatsReply} returns this
*/


proto.mdining.FoodStatsReply.prototype.setFoodstatsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.FoodStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.FoodStat}
 */


proto.mdining.FoodStatsReply.prototype.addFoodstats = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.FoodStat, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.FoodStatsReply} returns this
 */


proto.mdining.FoodStatsReply.prototype.clearFoodstatsList = function () {
  return this.setFoodstatsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.SummaryStatsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.SummaryStatsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.SummaryStatsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.SummaryStatsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      startdate: jspb.Message.getFieldWithDefault(msg, 1, ""),
      enddate: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.SummaryStatsRequest}
 */


proto.mdining.SummaryStatsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.SummaryStatsRequest();
  return proto.mdining.SummaryStatsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.SummaryStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.SummaryStatsRequest}
 */


proto.mdining.SummaryStatsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStartdate(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEnddate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.SummaryStatsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.SummaryStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.SummaryStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.SummaryStatsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStartdate();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getEnddate();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string startDate = 1;
 * @return {string}
 */


proto.mdining.SummaryStatsRequest.prototype.getStartdate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.SummaryStatsRequest} returns this
 */


proto.mdining.SummaryStatsRequest.prototype.setStartdate = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string endDate = 2;
 * @return {string}
 */


proto.mdining.SummaryStatsRequest.prototype.getEnddate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.SummaryStatsRequest} returns this
 */


proto.mdining.SummaryStatsRequest.prototype.setEnddate = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.SummaryStatsReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.SummaryStatsReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.SummaryStatsReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.SummaryStatsReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      stats: (f = msg.getStats()) && proto_foodstat_pb.SummaryStats.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.SummaryStatsReply}
 */


proto.mdining.SummaryStatsReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.SummaryStatsReply();
  return proto.mdining.SummaryStatsReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.SummaryStatsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.SummaryStatsReply}
 */


proto.mdining.SummaryStatsReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_foodstat_pb.SummaryStats();
        reader.readMessage(value, proto_foodstat_pb.SummaryStats.deserializeBinaryFromReader);
        msg.setStats(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.SummaryStatsReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.SummaryStatsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.SummaryStatsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.SummaryStatsReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStats();

  if (f != null) {
    writer.writeMessage(1, f, proto_foodstat_pb.SummaryStats.serializeBinaryToWriter);
  }
};
/**
 * optional SummaryStats stats = 1;
 * @return {?proto.mdining.SummaryStats}
 */


proto.mdining.SummaryStatsReply.prototype.getStats = function () {
  return (
    /** @type{?proto.mdining.SummaryStats} */
    jspb.Message.getWrapperField(this, proto_foodstat_pb.SummaryStats, 1)
  );
};
/**
 * @param {?proto.mdining.SummaryStats|undefined} value
 * @return {!proto.mdining.SummaryStatsReply} returns this
*/


proto.mdining.SummaryStatsReply.prototype.setStats = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.mdining.SummaryStatsReply} returns this
 */


proto.mdining.SummaryStatsReply.prototype.clearStats = function () {
  return this.setStats(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.mdining.SummaryStatsReply.prototype.hasStats = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.DiningHallsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.DiningHallsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.DiningHallsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.DiningHallsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.DiningHallsRequest}
 */


proto.mdining.DiningHallsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.DiningHallsRequest();
  return proto.mdining.DiningHallsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.DiningHallsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.DiningHallsRequest}
 */


proto.mdining.DiningHallsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.DiningHallsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.DiningHallsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.DiningHallsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.DiningHallsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.DiningHallsReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.DiningHallsReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.DiningHallsReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.DiningHallsReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.DiningHallsReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      dininghallsList: jspb.Message.toObjectList(msg.getDininghallsList(), proto_dininghalls_pb.DiningHall.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.DiningHallsReply}
 */


proto.mdining.DiningHallsReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.DiningHallsReply();
  return proto.mdining.DiningHallsReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.DiningHallsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.DiningHallsReply}
 */


proto.mdining.DiningHallsReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_dininghalls_pb.DiningHall();
        reader.readMessage(value, proto_dininghalls_pb.DiningHall.deserializeBinaryFromReader);
        msg.addDininghalls(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.DiningHallsReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.DiningHallsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.DiningHallsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.DiningHallsReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDininghallsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_dininghalls_pb.DiningHall.serializeBinaryToWriter);
  }
};
/**
 * repeated DiningHall diningHalls = 1;
 * @return {!Array<!proto.mdining.DiningHall>}
 */


proto.mdining.DiningHallsReply.prototype.getDininghallsList = function () {
  return (
    /** @type{!Array<!proto.mdining.DiningHall>} */
    jspb.Message.getRepeatedWrapperField(this, proto_dininghalls_pb.DiningHall, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.DiningHall>} value
 * @return {!proto.mdining.DiningHallsReply} returns this
*/


proto.mdining.DiningHallsReply.prototype.setDininghallsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.DiningHall=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.DiningHall}
 */


proto.mdining.DiningHallsReply.prototype.addDininghalls = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.DiningHall, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.DiningHallsReply} returns this
 */


proto.mdining.DiningHallsReply.prototype.clearDininghallsList = function () {
  return this.setDininghallsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.ItemsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.ItemsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.ItemsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.ItemsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.ItemsRequest}
 */


proto.mdining.ItemsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.ItemsRequest();
  return proto.mdining.ItemsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.ItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.ItemsRequest}
 */


proto.mdining.ItemsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.ItemsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.ItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.ItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.ItemsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.ItemsReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.ItemsReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.ItemsReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.ItemsReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      itemsMap: (f = msg.getItemsMap()) ? f.toObject(includeInstance, proto.mdining.Item.toObject) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.ItemsReply}
 */


proto.mdining.ItemsReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.ItemsReply();
  return proto.mdining.ItemsReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.ItemsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.ItemsReply}
 */


proto.mdining.ItemsReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getItemsMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.mdining.Item.deserializeBinaryFromReader, "", new proto.mdining.Item());
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.ItemsReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.ItemsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.ItemsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.ItemsReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getItemsMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.mdining.Item.serializeBinaryToWriter);
  }
};
/**
 * map<string, Item> items = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.mdining.Item>}
 */


proto.mdining.ItemsReply.prototype.getItemsMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.mdining.Item>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, proto.mdining.Item)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mdining.ItemsReply} returns this
 */


proto.mdining.ItemsReply.prototype.clearItemsMap = function () {
  this.getItemsMap().clear();
  return this;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FilterableEntriesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FilterableEntriesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FilterableEntriesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FilterableEntriesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FilterableEntriesRequest}
 */


proto.mdining.FilterableEntriesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FilterableEntriesRequest();
  return proto.mdining.FilterableEntriesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FilterableEntriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FilterableEntriesRequest}
 */


proto.mdining.FilterableEntriesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FilterableEntriesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FilterableEntriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FilterableEntriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FilterableEntriesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.FilterableEntriesReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FilterableEntriesReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FilterableEntriesReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FilterableEntriesReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FilterableEntriesReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      filterableentriesList: jspb.Message.toObjectList(msg.getFilterableentriesList(), proto_filterableentries_pb.FilterableEntry.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FilterableEntriesReply}
 */


proto.mdining.FilterableEntriesReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FilterableEntriesReply();
  return proto.mdining.FilterableEntriesReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FilterableEntriesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FilterableEntriesReply}
 */


proto.mdining.FilterableEntriesReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_filterableentries_pb.FilterableEntry();
        reader.readMessage(value, proto_filterableentries_pb.FilterableEntry.deserializeBinaryFromReader);
        msg.addFilterableentries(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FilterableEntriesReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FilterableEntriesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FilterableEntriesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FilterableEntriesReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFilterableentriesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_filterableentries_pb.FilterableEntry.serializeBinaryToWriter);
  }
};
/**
 * repeated FilterableEntry filterableEntries = 1;
 * @return {!Array<!proto.mdining.FilterableEntry>}
 */


proto.mdining.FilterableEntriesReply.prototype.getFilterableentriesList = function () {
  return (
    /** @type{!Array<!proto.mdining.FilterableEntry>} */
    jspb.Message.getRepeatedWrapperField(this, proto_filterableentries_pb.FilterableEntry, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.FilterableEntry>} value
 * @return {!proto.mdining.FilterableEntriesReply} returns this
*/


proto.mdining.FilterableEntriesReply.prototype.setFilterableentriesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.FilterableEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.FilterableEntry}
 */


proto.mdining.FilterableEntriesReply.prototype.addFilterableentries = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.FilterableEntry, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.FilterableEntriesReply} returns this
 */


proto.mdining.FilterableEntriesReply.prototype.clearFilterableentriesList = function () {
  return this.setFilterableentriesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.AllRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.AllRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.AllRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.AllRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.AllRequest}
 */


proto.mdining.AllRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.AllRequest();
  return proto.mdining.AllRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.AllRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.AllRequest}
 */


proto.mdining.AllRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.AllRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.AllRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.AllRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.AllRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.AllReply.repeatedFields_ = [1, 3];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.AllReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.AllReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.AllReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.AllReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      dininghallsList: jspb.Message.toObjectList(msg.getDininghallsList(), proto_dininghalls_pb.DiningHall.toObject, includeInstance),
      itemsMap: (f = msg.getItemsMap()) ? f.toObject(includeInstance, proto.mdining.Item.toObject) : [],
      filterableentriesList: jspb.Message.toObjectList(msg.getFilterableentriesList(), proto_filterableentries_pb.FilterableEntry.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.AllReply}
 */


proto.mdining.AllReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.AllReply();
  return proto.mdining.AllReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.AllReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.AllReply}
 */


proto.mdining.AllReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_dininghalls_pb.DiningHall();
        reader.readMessage(value, proto_dininghalls_pb.DiningHall.deserializeBinaryFromReader);
        msg.addDininghalls(value);
        break;

      case 2:
        var value = msg.getItemsMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.mdining.Item.deserializeBinaryFromReader, "", new proto.mdining.Item());
        });
        break;

      case 3:
        var value = new proto_filterableentries_pb.FilterableEntry();
        reader.readMessage(value, proto_filterableentries_pb.FilterableEntry.deserializeBinaryFromReader);
        msg.addFilterableentries(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.AllReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.AllReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.AllReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.AllReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDininghallsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_dininghalls_pb.DiningHall.serializeBinaryToWriter);
  }

  f = message.getItemsMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.mdining.Item.serializeBinaryToWriter);
  }

  f = message.getFilterableentriesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(3, f, proto_filterableentries_pb.FilterableEntry.serializeBinaryToWriter);
  }
};
/**
 * repeated DiningHall diningHalls = 1;
 * @return {!Array<!proto.mdining.DiningHall>}
 */


proto.mdining.AllReply.prototype.getDininghallsList = function () {
  return (
    /** @type{!Array<!proto.mdining.DiningHall>} */
    jspb.Message.getRepeatedWrapperField(this, proto_dininghalls_pb.DiningHall, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.DiningHall>} value
 * @return {!proto.mdining.AllReply} returns this
*/


proto.mdining.AllReply.prototype.setDininghallsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.DiningHall=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.DiningHall}
 */


proto.mdining.AllReply.prototype.addDininghalls = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.DiningHall, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.AllReply} returns this
 */


proto.mdining.AllReply.prototype.clearDininghallsList = function () {
  return this.setDininghallsList([]);
};
/**
 * map<string, Item> items = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.mdining.Item>}
 */


proto.mdining.AllReply.prototype.getItemsMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.mdining.Item>} */
    jspb.Message.getMapField(this, 2, opt_noLazyCreate, proto.mdining.Item)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mdining.AllReply} returns this
 */


proto.mdining.AllReply.prototype.clearItemsMap = function () {
  this.getItemsMap().clear();
  return this;
};
/**
 * repeated FilterableEntry filterableEntries = 3;
 * @return {!Array<!proto.mdining.FilterableEntry>}
 */


proto.mdining.AllReply.prototype.getFilterableentriesList = function () {
  return (
    /** @type{!Array<!proto.mdining.FilterableEntry>} */
    jspb.Message.getRepeatedWrapperField(this, proto_filterableentries_pb.FilterableEntry, 3)
  );
};
/**
 * @param {!Array<!proto.mdining.FilterableEntry>} value
 * @return {!proto.mdining.AllReply} returns this
*/


proto.mdining.AllReply.prototype.setFilterableentriesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.mdining.FilterableEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.FilterableEntry}
 */


proto.mdining.AllReply.prototype.addFilterableentries = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mdining.FilterableEntry, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.AllReply} returns this
 */


proto.mdining.AllReply.prototype.clearFilterableentriesList = function () {
  return this.setFilterableentriesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.MenuRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.MenuRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.MenuRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.MenuRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      date: jspb.Message.getFieldWithDefault(msg, 1, ""),
      meal: jspb.Message.getFieldWithDefault(msg, 2, ""),
      dininghall: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.MenuRequest}
 */


proto.mdining.MenuRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.MenuRequest();
  return proto.mdining.MenuRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.MenuRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.MenuRequest}
 */


proto.mdining.MenuRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDate(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMeal(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDininghall(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.MenuRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.MenuRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.MenuRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.MenuRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDate();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getMeal();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getDininghall();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string date = 1;
 * @return {string}
 */


proto.mdining.MenuRequest.prototype.getDate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.MenuRequest} returns this
 */


proto.mdining.MenuRequest.prototype.setDate = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string meal = 2;
 * @return {string}
 */


proto.mdining.MenuRequest.prototype.getMeal = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.MenuRequest} returns this
 */


proto.mdining.MenuRequest.prototype.setMeal = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string diningHall = 3;
 * @return {string}
 */


proto.mdining.MenuRequest.prototype.getDininghall = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.MenuRequest} returns this
 */


proto.mdining.MenuRequest.prototype.setDininghall = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.MenuReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.MenuReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.MenuReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.MenuReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.MenuReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      menusList: jspb.Message.toObjectList(msg.getMenusList(), proto_menu_pb.Menu.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.MenuReply}
 */


proto.mdining.MenuReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.MenuReply();
  return proto.mdining.MenuReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.MenuReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.MenuReply}
 */


proto.mdining.MenuReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_menu_pb.Menu();
        reader.readMessage(value, proto_menu_pb.Menu.deserializeBinaryFromReader);
        msg.addMenus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.MenuReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.MenuReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.MenuReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.MenuReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMenusList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_menu_pb.Menu.serializeBinaryToWriter);
  }
};
/**
 * repeated Menu menus = 1;
 * @return {!Array<!proto.mdining.Menu>}
 */


proto.mdining.MenuReply.prototype.getMenusList = function () {
  return (
    /** @type{!Array<!proto.mdining.Menu>} */
    jspb.Message.getRepeatedWrapperField(this, proto_menu_pb.Menu, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.Menu>} value
 * @return {!proto.mdining.MenuReply} returns this
*/


proto.mdining.MenuReply.prototype.setMenusList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.Menu=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.Menu}
 */


proto.mdining.MenuReply.prototype.addMenus = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.Menu, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.MenuReply} returns this
 */


proto.mdining.MenuReply.prototype.clearMenusList = function () {
  return this.setMenusList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FoodRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FoodRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FoodRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FoodRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      date: jspb.Message.getFieldWithDefault(msg, 2, ""),
      startdate: jspb.Message.getFieldWithDefault(msg, 3, ""),
      enddate: jspb.Message.getFieldWithDefault(msg, 4, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FoodRequest}
 */


proto.mdining.FoodRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FoodRequest();
  return proto.mdining.FoodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FoodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FoodRequest}
 */


proto.mdining.FoodRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDate(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStartdate(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEnddate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FoodRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FoodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FoodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FoodRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getDate();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getStartdate();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getEnddate();

  if (f.length > 0) {
    writer.writeString(4, f);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.mdining.FoodRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.FoodRequest} returns this
 */


proto.mdining.FoodRequest.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string date = 2;
 * @return {string}
 */


proto.mdining.FoodRequest.prototype.getDate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.FoodRequest} returns this
 */


proto.mdining.FoodRequest.prototype.setDate = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string startDate = 3;
 * @return {string}
 */


proto.mdining.FoodRequest.prototype.getStartdate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.FoodRequest} returns this
 */


proto.mdining.FoodRequest.prototype.setStartdate = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string endDate = 4;
 * @return {string}
 */


proto.mdining.FoodRequest.prototype.getEnddate = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.mdining.FoodRequest} returns this
 */


proto.mdining.FoodRequest.prototype.setEnddate = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.FoodReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.FoodReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.FoodReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.FoodReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.FoodReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      foodsList: jspb.Message.toObjectList(msg.getFoodsList(), proto_food_pb.Food.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.FoodReply}
 */


proto.mdining.FoodReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.FoodReply();
  return proto.mdining.FoodReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.FoodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.FoodReply}
 */


proto.mdining.FoodReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_food_pb.Food();
        reader.readMessage(value, proto_food_pb.Food.deserializeBinaryFromReader);
        msg.addFoods(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.FoodReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.FoodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.FoodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.FoodReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFoodsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_food_pb.Food.serializeBinaryToWriter);
  }
};
/**
 * repeated Food foods = 1;
 * @return {!Array<!proto.mdining.Food>}
 */


proto.mdining.FoodReply.prototype.getFoodsList = function () {
  return (
    /** @type{!Array<!proto.mdining.Food>} */
    jspb.Message.getRepeatedWrapperField(this, proto_food_pb.Food, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.Food>} value
 * @return {!proto.mdining.FoodReply} returns this
*/


proto.mdining.FoodReply.prototype.setFoodsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.Food=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.Food}
 */


proto.mdining.FoodReply.prototype.addFoods = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.Food, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.FoodReply} returns this
 */


proto.mdining.FoodReply.prototype.clearFoodsList = function () {
  return this.setFoodsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.HeartsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.HeartsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.HeartsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.HeartsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.HeartsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      keysList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.HeartsRequest}
 */


proto.mdining.HeartsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.HeartsRequest();
  return proto.mdining.HeartsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.HeartsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.HeartsRequest}
 */


proto.mdining.HeartsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addKeys(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.HeartsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.HeartsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.HeartsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.HeartsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getKeysList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string keys = 1;
 * @return {!Array<string>}
 */


proto.mdining.HeartsRequest.prototype.getKeysList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/**
 * @param {!Array<string>} value
 * @return {!proto.mdining.HeartsRequest} returns this
 */


proto.mdining.HeartsRequest.prototype.setKeysList = function (value) {
  return jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mdining.HeartsRequest} returns this
 */


proto.mdining.HeartsRequest.prototype.addKeys = function (value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.HeartsRequest} returns this
 */


proto.mdining.HeartsRequest.prototype.clearKeysList = function () {
  return this.setKeysList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.mdining.HeartsReply.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.mdining.HeartsReply.prototype.toObject = function (opt_includeInstance) {
    return proto.mdining.HeartsReply.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.mdining.HeartsReply} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.mdining.HeartsReply.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      countsList: jspb.Message.toObjectList(msg.getCountsList(), proto_hearts_pb.HeartCount.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mdining.HeartsReply}
 */


proto.mdining.HeartsReply.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mdining.HeartsReply();
  return proto.mdining.HeartsReply.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mdining.HeartsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mdining.HeartsReply}
 */


proto.mdining.HeartsReply.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto_hearts_pb.HeartCount();
        reader.readMessage(value, proto_hearts_pb.HeartCount.deserializeBinaryFromReader);
        msg.addCounts(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.mdining.HeartsReply.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.mdining.HeartsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mdining.HeartsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.mdining.HeartsReply.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto_hearts_pb.HeartCount.serializeBinaryToWriter);
  }
};
/**
 * repeated HeartCount counts = 1;
 * @return {!Array<!proto.mdining.HeartCount>}
 */


proto.mdining.HeartsReply.prototype.getCountsList = function () {
  return (
    /** @type{!Array<!proto.mdining.HeartCount>} */
    jspb.Message.getRepeatedWrapperField(this, proto_hearts_pb.HeartCount, 1)
  );
};
/**
 * @param {!Array<!proto.mdining.HeartCount>} value
 * @return {!proto.mdining.HeartsReply} returns this
*/


proto.mdining.HeartsReply.prototype.setCountsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.mdining.HeartCount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mdining.HeartCount}
 */


proto.mdining.HeartsReply.prototype.addCounts = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mdining.HeartCount, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mdining.HeartsReply} returns this
 */


proto.mdining.HeartsReply.prototype.clearCountsList = function () {
  return this.setCountsList([]);
};

goog.object.extend(exports, proto.mdining);